import { ProductTile } from '@/components/ProductTile';
import { useSearchData } from '@/contexts/searchContext';
import type { Product } from '@/types';

interface SearchProductTileProps {
  index?: number;
  product: Product;
}

export const SearchProductTile = ({ index, product }: SearchProductTileProps) => {
  const { showMoreLikeThis } = useSearchData();

  return (
    <ProductTile
      index={index}
      listName="search-results"
      product={product}
      showMoreLikeThis={showMoreLikeThis}
    />
  );
};
